module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./~/rc-switch/es/index.js
// module id = 1576
// module chunks = 14